import Konva from 'konva';
import { _registerNode } from 'konva/lib/Global';

class CircledNumber extends Konva.Group {
  constructor(attrs){
    const { circle, text, radius } = attrs;
    attrs.width = radius;
    attrs.height = radius;

    super(attrs)

    this.className = this.constructor.name

    circle.radius = radius;

    text.width = radius;
    text.height = radius;
    text.x = - radius * 0.5; //Defaults to zero
    text.y = - radius * 0.5; //Default to zero

    this.circle = new Konva.Circle(circle);
    this.number = new Konva.Text(text);
    this.add(this.circle);
    this.add(this.number);
  }

  getNode(){
    return this;
  }

  // Konva prevents shape that are not groups or basic ones to be added to the layer
  // with this we'd allow it.
  getType(){
    return 'Group';
  }
}

// Need to register the node to Konva, so it detects it as a valid shape
// and things like Konva.Node.crate({ className: 'LineTransformer }) works
// which is what we do when we paste in annotations.
CircledNumber.prototype.nodeType = 'CircledNumber';
_registerNode(CircledNumber);